import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Modal } from '@mantine/core';

import { FunnelForm } from './Form';

import { useAddFunnel } from '@/features/pages';

export const AddFunnelModal = NiceModal.create(({ pageId }: { pageId: string }) => {
  const modal = useModal();

  const { mutate, isLoading } = useAddFunnel({ pageId, onSuccess: modal.hide });

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={modal.remove}
      title="New funnel"
    >
      <FunnelForm isLoading={isLoading} onSubmit={(params) => mutate({ ...params, pageId })} />
    </Modal>
  );
});
